import {useAuthContext} from '../context/AuthContext';

interface UnauthenticatedTemplateProps {
    children?: React.ReactNode;
}

export const UnauthenticatedTemplate: React.FC<
    UnauthenticatedTemplateProps
> = ({children}) => {
    const {isAuthenticated} = useAuthContext();

    if (!isAuthenticated) {
        return <>{children}</>;
    }
    return <></>;
};
